export default __webpack_public_path__ + "assets/sunrise.749e354e.svg";